import React from "react";
import { connect } from "react-redux";
import get from "lodash/get";
import { SocialShare } from "@quintype/components";
import { object, array, number, string } from "prop-types";

import SupportQuint from "../support-quint";
import SocialShareLinks from "../../../molecules/social-share";
import AlsoWatch from "../../../molecules/also-watch";
import AlsoRead from "../../../rows/also-read";
import MoreFromFit from "../../../rows/more-from-fit";

import "./bottom-elements.m.css";

const BottomStoryElements = ({ story, items, index, merchantId, publisherName }) => {
  return (
    <div styleName="wrapper">
      <SupportQuint storyId={story.id} publisherName={publisherName} />
      <SocialShare
        storyId={story.id}
        template={SocialShareLinks}
        title={story.headline}
        url={story.slug}
        color="#fff"
      />
      <MoreFromFit story={story} publisherName={publisherName} />
      <AlsoWatch index={index} />
      <div styleName="also-read-bottom">
        <AlsoRead publisherName={publisherName} list={items} merchantId={merchantId} name="Also Read Bottom" />
      </div>
    </div>
  );
};

BottomStoryElements.propTypes = {
  story: object,
  items: array,
  index: number,
  merchantId: number,
  publisherName: string,
};

const mapStateToProps = (state) => {
  const WruItems = get(state, ["storyReducer", "wruData"], []);
  const items = WruItems.find((i) => i.category === "also_read_bottom");

  return {
    items: (items && items.recommendations) || [],
    merchantId: get(state, ["qt", "config", "publisher-attributes", "wru_id"]),
    publisherName: get(state, ["qt", "config", "publisher-attributes", "name"], null),
  };
};

export default connect(mapStateToProps, null)(BottomStoryElements);
